// Add your custom JS here.
$("#map-spain g").on("click", function () {
	var $t = $(this);
	var input_province = $("#input-center-province");
	var province = $t.data("province");
	if (province && input_province) {
		$(`#input-center-province option:contains('${province}')`)
			.attr("selected", true)
			.trigger("change");
	}
});

$("#input-center-province").on("change", function () {
	var $t = $(this);
	var map = $("#map-spain");
	map.find("g").removeClass("active");
	map
		.find(`g[data-province="${$t.find("option:selected").text()}"]`)
		.addClass("active");
	console.log(`#map-spain g[data-province=${$t.text()}]`);
});
